import { Button, IconPlus, IconUsers, Text, Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Item } from 'typings'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  RuleStack,
  Tag,
  TagsListTruncate,
} from 'ui'
import { messages } from './messages'
import { styles } from './styles'

type Props = {
  values: Item[] | undefined
  onAdd: () => void
  onRemove: () => void
}

export function AudienceView(props: Props) {
  const { values, onAdd, onRemove } = props

  const { $t } = useIntl()

  return (
    <div>
      {!values ? (
        <Button variant="secondary" icon={<IconPlus />} onClick={onAdd}>
          <FormattedMessage {...messages.view.add} />
        </Button>
      ) : (
        <RuleStack>
          <Rule onClick={onAdd}>
            <RuleIcon>
              <IconUsers />
            </RuleIcon>
            <RuleDescription>
              <FormattedMessage
                {...messages.view.description}
                values={{
                  count: values.length,
                  b: (content) => <Text variant="body">{content}</Text>,
                }}
              />
            </RuleDescription>
            <RuleContent>
              <TagsListTruncate
                content={values.map(({ name }) => name)}
                lines={7}
              >
                {values.map((item, index) => (
                  <TagsListTruncate.Atom key={index}>
                    <Tooltip
                      text={$t(messages.view.item, {
                        name: item.name,
                        id: item.id,
                      })}
                    >
                      <Tag className={styles.tag}>{item.name}</Tag>
                    </Tooltip>
                  </TagsListTruncate.Atom>
                ))}
              </TagsListTruncate>
            </RuleContent>
            <RuleActions>
              <RuleDefaultActions onEdit={onAdd} onRemove={onRemove} />
            </RuleActions>
          </Rule>
        </RuleStack>
      )}
    </div>
  )
}
